<script>
    export let modifiedEquipment;
</script>

<div class="card">
    <div class="card-body">
        <div class="card-head">
            <h2 class="card-title">Alert Thresholds</h2>
        </div>

        <div class="padding-top" style="width: 60%">
            <h3>Danger</h3>

            <h5>Value (%)</h5>
            <input type="number" class="card-highlight" bind:value={modifiedEquipment.infos.thresholds.danger.value}/>

            <h5 class="padding-top">Display (display units)</h5>
            <input class="card-highlight" bind:value={modifiedEquipment.infos.thresholds.danger.display}/>

            <h3 class="padding-top">Warning</h3>
            <h5>Value (%)</h5>
            <input type="number" class="card-highlight" bind:value={modifiedEquipment.infos.thresholds.warning.value}/>

            <h5 class="padding-top">Display (display units)</h5>
            <input class="card-highlight" bind:value={modifiedEquipment.infos.thresholds.warning.display}/>
        </div>
    </div>
</div>